import React from 'react';
import { Button } from './ui/button';
import { Clock, PhoneCall } from 'lucide-react';

const FinalCTA = ({ onOpenForm }) => {
  return (
    <section className="py-20 bg-gradient-to-br from-gray-900 via-red-900 to-gray-900 text-white relative overflow-hidden">
      {/* Animated Background */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0 bg-gradient-to-r from-red-500 to-orange-500 animate-pulse"></div>
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-5xl relative z-10">
        <div className="text-center">
          {/* Urgency Badge */}
          <div className="inline-flex items-center gap-2 bg-red-600 text-white px-6 py-3 rounded-full mb-8 animate-bounce">
            <Clock className="w-5 h-5" />
            <span className="font-bold text-lg">Vagas Limitadas!</span>
          </div>

          {/* Main Heading */}
          <h2 className="text-4xl md:text-6xl font-bold mb-6 leading-tight">
            Não perca sua <span className="text-red-400">vaga!</span>
          </h2>

          {/* Subheading */}
          <p className="text-2xl md:text-3xl text-gray-200 mb-12 font-semibold">
            Reserve agora e garanta seu lugar no paraíso
          </p>

          {/* CTA Button */}
          <Button
            onClick={onOpenForm}
            size="lg"
            className="bg-green-600 hover:bg-green-700 text-white px-10 py-7 text-xl font-bold rounded-full shadow-2xl hover:shadow-green-500/50 transition-all duration-300 hover:scale-110 animate-pulse-glow"
          >
            <PhoneCall className="mr-3 h-6 w-6" />
            Solicitar Orçamento Agora
          </Button>

          {/* Trust Indicator */}
          <p className="mt-8 text-gray-300 text-lg max-w-2xl mx-auto">
            Atendimento rápido e personalizado via WhatsApp
          </p>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;
